const defaultSettings = {
  usePointerNav: true
}

class Settings {
  constructor() {
    this.storage = window.localStorage;
    this.data = this.loadData();
  }

  loadData() {
    let data = this.readData();

    if (data === null) {
      data = defaultSettings;
      this.writeData(data);
    }

    return data;
  }

  readData() {
    return JSON.parse(this.storage.getItem("caldera.settings"));
  }

  writeData(data) {
    this.storage.setItem("caldera.settings", JSON.stringify(data));
  }

  persist() {
    this.writeData(this.data);
  }

  get usePointerNav() {
    return this.data.usePointerNav;
  }

  set usePointerNav(value) {
    this.data.usePointerNav = value;
  }
}

const settings = new Settings();

window.addEventListener("beforeunload", () => {
  settings.persist();
});

export default settings;